"use client"

import { MobileStepper } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Box, Button } from '@mui/material';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';

interface Step {
    id: string
    label: string
    required: boolean
}

interface OnboardingStepperProps {
    steps: Step[]
    currentStep: number
    onStepClick: (index: number) => void
    onNext: () => void
    onBack: () => void
}

export default function OnboardingStepper({ steps, currentStep, onStepClick, onNext, onBack }: OnboardingStepperProps) {
    const theme = useTheme();

    return (
        <Box sx={{
            width: '100%',
            mb: { xs: 2, sm: 4 },
            display: 'flex',
            flexDirection: 'column',
            gap: 2
        }}>
            <Box sx={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                px: { xs: 0.5, sm: 2 }
            }}>
                <Button
                    size="small"
                    onClick={onBack}
                    disabled={currentStep === 0}
                    startIcon={
                        theme.direction === 'rtl'
                            ? <KeyboardArrowRight sx={{ fontSize: { xs: '18px', sm: '20px' } }} />
                            : <KeyboardArrowLeft sx={{ fontSize: { xs: '18px', sm: '20px' } }} />
                    }
                    sx={{
                        color: '#7b63ab',
                        fontSize: { xs: '0.75rem', sm: '0.875rem' },
                        minWidth: { xs: '60px', sm: '70px' },
                        px: { xs: 0.5, sm: 1 },
                        '&.Mui-disabled': {
                            opacity: 0.5
                        }
                    }}
                >
                    Back
                </Button>

                <Box sx={{ flex: 1, mx: { xs: 1, sm: 2 } }}>
                    <MobileStepper
                        variant="dots"
                        steps={steps.length}
                        position="static"
                        activeStep={currentStep}
                        sx={{
                            background: 'transparent',
                            '& .MuiMobileStepper-dots': {
                                width: '100%',
                                display: 'flex',
                                justifyContent: 'center',
                                gap: { xs: '4px', sm: '8px' }
                            },
                            '& .MuiMobileStepper-dot': {
                                width: { xs: '6px', sm: '8px' },
                                height: { xs: '6px', sm: '8px' },
                                backgroundColor: '#e0e0e0',
                            },
                            '& .MuiMobileStepper-dotActive': {
                                backgroundColor: '#7b63ab',
                                width: { xs: '8px', sm: '10px' },
                                height: { xs: '8px', sm: '10px' }
                            },

                        }}
                        backButton={null}
                        nextButton={null}
                    />
                </Box>

                <Button
                    size="small"
                    onClick={onNext}
                    disabled={currentStep === steps.length - 1}
                    endIcon={
                        theme.direction === 'rtl'
                            ? <KeyboardArrowLeft sx={{ fontSize: { xs: '18px', sm: '20px' } }} />
                            : <KeyboardArrowRight sx={{ fontSize: { xs: '18px', sm: '20px' } }} />
                    }
                    sx={{
                        color: '#7b63ab',
                        fontSize: { xs: '0.75rem', sm: '0.875rem' },
                        minWidth: { xs: '60px', sm: '70px' },
                        px: { xs: 0.5, sm: 1 },
                        '&.Mui-disabled': {
                            opacity: 0.5
                        }
                    }}
                >
                    Next
                </Button>
            </Box>
        </Box>
    );
}
